export default "__VITE_ASSET__CSh5ody1__"